import React, { useEffect, useState } from 'react'
// Material-UI
import { makeStyles, Card, Container, Grid, Typography } from '@material-ui/core';
// Components
import NavbarUser from '../components/NavbarUser';
import TitlePage from '../components/TitlePageUser';
import Background from "../components/BackgroundPattern";
import Footer from '../components/Footer';
// import foto from '../../../assets/image/fotoProfile.jpg';
// Data
import DataUser from '../data/DataUser';
//Service
import pesertaService from '../services/pesertaService'

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  image: {
    width: theme.spacing(20),
    borderRadius: "5px",
  },
  section: {
    margin: theme.spacing(2,0),
    padding: theme.spacing(2,2),
    backgroundColor: theme.palette.danger.main,
    color: "white"
  },
}));

const FotoProfile = ( {classes} ) => {
  return (
    <section id="foto-profile">
      <Container>
        <img src={process.env.REACT_APP_API_URL + classes.dataProfil.file_foto} alt="foto-peserta" className={classes.image} />
      </Container>
    </section>
  )
}

const DataProfile = ( {classes} ) => {
  const profileStructure = ['nama_lengkap', 'noreg', 'prodi', 'fakultas', 'angkatan', 'golongan_darah'];
  const dataProfile = DataUser.map((data, index) => 
    <Grid container alignItems="center" key={index}>
      <Grid item xs={4} md={2} >
        <Typography variant="body1" paragraph>
          {data.label}
        </Typography>
      </Grid>
      <Grid item xs={8} md={10} >
        <Typography variant="body1" paragraph>
          {classes.dataProfil[profileStructure[index]]}
        </Typography>
      </Grid>
    </Grid>
  )

  return (
    <section id="data-profile" >
      <Container>
        <Card className={classes.section} elevation={3}>
          <Container>
            {dataProfile}
          </Container>
        </Card>
      </Container>
    </section>
  )
}

const UserProfile = () => {
  const classes = useStyles();
  const [showDataProfile, setDataProfile] = useState({});

  useEffect(() => {
    pesertaService.getUserProfile()
    .then(result => {
      result = result.data.data;
      setDataProfile(...result)
    })
    .catch(e => {
      console.log(e)
    })

  }, [setDataProfile]);

  classes.dataProfil = showDataProfile;

  return (
    <section id="user-profile" className={classes.container}>
      <Background/>
      <NavbarUser/>
        <Container style={{flex: "1"}}>
          <TitlePage text="Profil Peserta"/>
            <FotoProfile classes={classes}/>
            <DataProfile classes={classes}/>
        </Container>
      <Footer/>
    </section>
  )
}

export default UserProfile
